const fields = [
  {
    key: 'vehicle',
    label: 'report.fields.licensePlate',
    header: 'licensePlate',
    filter: true,
    width: 20,
    disabled: false,
  },
  {
    key: 'vehicleType',
    label: 'report.fields.vehicleType',
    header: 'vehicleType',
    filter: false,
    width: 20,
    disabled: false,
  },
  {
    key: 'hullNo',
    label: 'report.fields.hullNo',
    header: 'hullNo',
    filter: false,
    width: 20,
    disabled: false,
    formatter: (val) => {
      return val !== null ? val : '-'
    },
  },
  {
    key: 'startTime',
    label: 'report.fields.startTime',
    header: 'startTime',
    filter: false,
    width: 20,
    disabled: true,
  },
  {
    key: 'stopTime',
    label: 'report.fields.endTime',
    header: 'stopTime',
    filter: false,
    width: 20,
    disabled: true,
  },
  {
    key: 'engineOnDuration',
    label: 'report.fields.duration',
    header: 'engineOnDuration',
    filter: false,
    width: 20,
    disabled: false,
  },
  {
    key: 'startLocation',
    label: 'report.fields.startLocation',
    header: 'startLocation',
    filter: false,
    width: 20,
    disabled: false,
  },
  {
    key: 'stopLocation',
    label: 'report.fields.endLocation',
    header: 'stopLocation',
    filter: false,
    width: 20,
    disabled: false,
  },
]
export default fields
